<template>
    <div class="supplier-paybill-report-container">
        <div class="t-top-bar">
            <div class="report-op">
              <el-select id="supplierSelect" filterable class="search-input" v-model="supplierId" placeholder="选择客户">
                <el-option v-for="(val,key) in supplierList" :key="key" :label="val.supplierName" :value="val.supplierId"></el-option>
              </el-select>
              <el-date-picker v-model="selectTime" type="datetimerange"
                              range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                              align="right"></el-date-picker>
            </div>
          <div class="report-op"><el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button></div>
          <div class="report-op"><el-button style="margin: 0" type="primary"  @click="print">打印</el-button></div>
          <div class="report-op"><el-button style="margin: 0" type="primary"  @click="addHandler">添加</el-button></div>
          <div class="report-op"><i class="el-icon-download l-add-buttion" @click="exportExcel"></i></div>
        </div>
        <el-table id="printTable" :data="tableData" border style="width: 100%"  height="640" v-loading="listLoading">
          <el-table-column type="index" prop="supplier_name" label="序号" width="50px"></el-table-column>
          <el-table-column prop="supplierName" label="收款人"></el-table-column>
          <el-table-column prop="amount" label="付款金额(元)"></el-table-column>
          <el-table-column prop="payTime" label="付款日期">
            <template slot-scope="scope">
              {{scope.row.payTime | formateTime()}}
            </template>
          </el-table-column>
          <el-table-column prop="supplyTime" label="供货日期">
            <template slot-scope="scope">
              {{scope.row.supplyTime | formateTime()}}
            </template>
          </el-table-column>
          <el-table-column prop="subject" label="科目"></el-table-column>
          <el-table-column prop="append" label="摘要"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <i class="el-icon-edit el-icon-table btn-primary" @click="editHandler(scope.row)"></i>
              <i class="el-icon-delete el-icon-table btn-danger" @click="delHandler(scope.row)"></i>
            </template>
          </el-table-column>
        </el-table>


      <el-dialog :title="opFlag=='add'?'添加付款记录':'修改付款记录'" :visible.sync="addPayDialogVisiable"
                 @close="addPayCloseHandler"  width="650px">
        <el-form :model="addForm" :rules="rules" ref="addForm">
          <el-form-item label="付款日期" prop="payTime" :label-width="formLabelWidth">
            <el-date-picker  v-model="addForm.payTime" type="datetime" placeholder="选择付款日期" align="right"></el-date-picker>
          </el-form-item>
          <el-form-item label="付款明细" prop="item" :label-width="formLabelWidth">
            <el-input type="textarea"
                 placeholder="格式：xxxx-x-x xx.xx。多条用英文逗号,分隔" v-model="addForm.item">
            </el-input>
          </el-form-item>
          <el-form-item label="收款人" prop="payee" :label-width="formLabelWidth">
            <el-select filterable v-model="addForm.supplierId" placeholder="收款人">
              <el-option v-for="(val,key) in supplierList" :key="key" :label="val.supplierName" :value="val.supplierId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="科目" prop="subject" :label-width="formLabelWidth">
            <el-select v-model="addForm.subject" placeholder="请选择科目">
              <el-option v-for="(val,key) in selectDic('PAY_SUBJECT')" :key="key" :label="val.name" :value="val.code"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="付款金额" prop="amount" :label-width="formLabelWidth">
            <el-input type="number" v-model="addForm.amount" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="摘要" prop="append" :label-width="formLabelWidth">
            <el-select v-model="addForm.append" placeholder="请选择摘要">
              <el-option v-for="(val,key) in selectDic('PAY_SUBJECT')" :key="key" :label="val.name" :value="val.code"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="addPayDialogVisiable = false">取 消</el-button>
          <el-button type="primary" @click="addConfirm">确 定</el-button>
        </div>
      </el-dialog>
    </div>
</template>

<script>
import {getSupplierList} from '../../api/supplier'
    import { tableDataToExcelSample, dataprint, formateTime} from '../../util/util'
    import { addSupplayPayBill, updateSupplayPayBill,deleteSupplyPayBill,getSupplayPayBillList,getSupplierPayable} from '../../api/supplyPayBill'
    import localCache from "../../util/localCache";
    import {addProduction, updateProduction} from "@/api/prouction";
    export default {
        name: "supplierStatisticsReportContainer",
        data(){
          let reg = /^\d{4}\-\d{1,2}\-\d{1,2} \d{0,6}\.{0,1}\d{0,3}$/
          let validateItem = (rule, value, callback) => {
            if (value === '') {
              callback(new Error('请填写付款明细'));
            } else {
              let arr = value.split(',')
              for (let i = 0, len = arr.length; i < len; i++) {
                if(!reg.test(arr[i])){
                  callback(new Error('格式错误'));
                }
              }
              callback();
            }
          };
            return {
                listLoading: false,
                tableHead: [],
                tableData: [],
                selectTime: '',
                keyword: '',
                searchDepart:'',
                treeData: [],
                priceType:'',
                supplierId: '',
                supplierList: [],
              payTableData: [],
              addPayDialogVisiable: false,
              addForm:{
                payTime:'',
                supplierId:'',
                item:'',
                payee:'',
                subject:'',
                amount:'',
                append:'',
              },
              formLabelWidth: '120px',
              opFlag:'add',
              rules:{
                payTime: [
                  { required: true, message: '请选择付款日期', trigger: 'blur' },
                ],
                item: [
                  { required: true, message: '请填写付款明细', trigger: 'blur' },
                  { validator: validateItem, trigger: 'blur' }
                ],
                supplierId: [
                  { required: true, message: '请选择收款人', trigger: 'blur' },
                  // { min: 2, max: 32, message: '长度在 2 到 32 个字符', trigger: 'blur' }
                ],
                subject: [
                  { min: 1, max: 32, message: '长度在 1 到 32 个字符', trigger: 'blur' }
                ],
                append: [
                  { min: 1, max: 255, message: '长度在 1 到 255 个字符', trigger: 'blur' }
                ]
              },
              selectRow: ''
            }
        },
        mounted(){
          let now = new Date()
          let end = new Date(now.getFullYear(),now.getMonth(),now.getDate(),0,0);
          this.selectTime = [end,now]

          this.getSupplierList_();
        },
        methods: {
          delHandler(row){
            this.$msgbox.confirm('确认删除？')
                .then(_ => {
                  deleteSupplyPayBill({
                    id: row.id,
                    customerId: localCache.getCurrentCustomerId()
                  }).then((res)=>{
                    if(res.errorcode==0){
                      this.$message.success('删除成功')
                      this.getRecordList_()
                    }else{
                      this.$message.error(res.message)
                    }
                  })
                }).catch(_ => {});
          },
          editHandler(row){
            this.selectRow = row
            this.opFlag='edit'
            this.addForm = Object.assign({}, row)
            this.addForm.payTime = new Date(row.payTime * 1000)
            let itemList = row.itemList
            let str = []
            for (let i = 0, len = itemList.length; i < len; i++) {
              str.push(formateTime(itemList[i].supplyTime, 'yyyy-MM-dd') +' '+ itemList[i].amount)
            }
            // this.addForm.item = ''
            this.$set(this.addForm, 'item', str.join(','))
            this.addPayDialogVisiable = true
          },
          addHandler(){
            this.opFlag = 'add'
            this.addPayDialogVisiable = true
          },
          addConfirm(){
            this.$refs['addForm'].validate((valid) => {
              if (!valid) {
                return
              }
              let param = Object.assign({}, this.addForm)
              if(this.opFlag == 'add'){

              }else if(this.opFlag == 'edit'){
                param.productionId = this.selectRow.productionId
              }
              param.customerId = localCache.getCurrentCustomerId()
              param.payTime = new Date(this.addForm.payTime).getTime() / 1000
              let itemList = []
              let arr = param.item.split(',')
              for (let i = 0, len = arr.length; i < len; i++) {
                let a = arr[i].split(' ')

                itemList.push({
                  supplyTime: new Date(a[0]).getTime()/1000,
                  payTime: param.payTime,
                  amount: a[1].replace('元', '')
                })
              }
              param.itemListStr = JSON.stringify(itemList)
              if(this.opFlag=='add'){
                addSupplayPayBill(param).then((res)=>{
                  if(res.errorcode==0){
                    this.$message.success('添加成功')
                    this.addPayDialogVisiable = false
                    this.getRecordList_()
                  }else{
                    this.$message.error(res.message)
                  }
                })
              }else{
                updateSupplayPayBill(param).then((res)=>{
                  if(res.errorcode==0){
                    this.$message.success('修改成功')
                    this.addPayDialogVisiable = false
                    this.getRecordList_()
                  }else{
                    this.$message.error(res.message)
                  }
                })
              }
            });
          },
          addPayCloseHandler(){
            this.$refs['addForm'].resetFields()
            this.addForm =  {
              payTime:'',
              supplierId:'',
              item:'',
              payee:'',
              subject:'',
              amount:'',
              append:'',
            }
          },

          payClick(row){
            this.payDialogVisiable=true
            let param = {
              customerId: localCache.getCurrentCustomerId(),
              beginTime: parseInt(this.selectTime[0].getTime()/1000),
              endTime: parseInt(this.selectTime[1].getTime()/1000),
              supplierId:row.supplier_id
            }
            getSupplayPayBillList(param).then((res)=>{
              if(res.errorcode == 0){
                this.tableData = res.data
              }
            })
          },
          getSupplierList_(){
            let param = {
              customerId: localCache.getCurrentCustomerId(),
            }
            getSupplierList(param).then(res => {
              if (res.errorcode !== 0) {
                this.$message.error(res.message)
              } else {
                this.supplierList = res.data
              }
            }).catch(() => {
            })
          },
          print(){
            var printHTML = document.getElementById('printTable').innerHTML; // 获取要打印的内容

            dataprint(printHTML)
          },
            exportExcel(){
              // let date = new Date(this.selectTime)
              let title = `付款单`
              let str = document.querySelector('.el-table__header').innerHTML
              let body = document.querySelector('.el-table__body').innerHTML
              // let selectProduction = document.getElementById('productionSelect').value
              // let selectSupplier = document.getElementById('supplierSelect').value

              tableDataToExcelSample(str+body,title)
            },
            search(){
                this.getRecordList_()
            },
          getRecordList_(){
                if(!this.selectTime){
                    this.$message.error('请选择时间')
                    return
                }
                this.listLoading = true
                let param = {
                  customerId: localCache.getCurrentCustomerId(),
                  beginTime: parseInt(this.selectTime[0].getTime()/1000),
                  endTime: parseInt(this.selectTime[1].getTime()/1000),
                  supplierId:this.supplierId
                }
            getSupplayPayBillList(param).then(res => {
                    this.listLoading = false
                    if (res.errorcode !== 0) {
                        this.$message.error(res.message)
                    } else {
                        let arr = res.data
                        let sum = 0
                        arr.forEach((t)=>{
                          sum += t.amount
                        })
                        arr.push({
                          amount: sum.toFixed(2),
                          supplierName: '合计'
                        })
                      this.tableData = arr
                    }
                }).catch(() => {
                    this.listLoading = false
                })
            },
            datasort(data){
              return data.sort((t1,t2)=>{
                let r = t1.spec_name.replace('/','') > t2.spec_name.replace('/','')
                if(r){
                  return 1
                }else{
                  return -1;
                }
              })
            },
        }
    }
</script>

<style lang="scss">
    .supplier-paybill-report-container{
        .t-top-bar{
            display: flex;
        }
        .report-op{
            margin-right: 15px;
        }
        .report-op:last-child{
            margin-left: auto;
        }
        .search-input{
            width: 250px;
            margin-right: 15px;
        }
        .search-input200{
            width: 200px;
            margin-right: 15px;
        }
        .el-table td{
            padding: 0;
        }
    }

</style>
